import { isAxiosError } from 'axios';

import api from 'mastodon/api';

export const MAX_SWITCHABLE_ACCOUNTS = 5;

interface RedirectResponse {
  redirect_to?: string;
}

async function postAndFollowRedirect(url: string, data?: object) {
  const response = await api(false).post<RedirectResponse>(url, data, {
    headers: { Accept: 'application/json' },
    withCredentials: true,
  });

  if (response.data.redirect_to) {
    window.location.href = response.data.redirect_to;
  } else {
    throw new Error('Unexpected response from the server');
  }
}

/**
 * Switches to another account this browser is already signed in to, and
 * reloads the current page as that account. Pages the new account cannot see
 * show their usual "not found" or permission error.
 */
export async function switchAccount(accountId: string) {
  await api(false).post(
    '/auth/account_switch',
    { account_id: accountId },
    { headers: { Accept: 'application/json' }, withCredentials: true },
  );

  // A full page load is needed: the access token and initial state belong
  // to the account that was active when the page was rendered.
  window.location.reload();
}

/**
 * Leaves the current account signed in in the background and opens the
 * sign-in page, so that another account can be added.
 */
export function addAccount() {
  return postAndFollowRedirect('/auth/account_addition');
}

export function errorMessageFrom(error: unknown): string | undefined {
  if (isAxiosError<{ error?: string }>(error)) {
    return error.response?.data.error;
  }

  return undefined;
}
